import React from 'react';
import PropTypes from 'prop-types';
import TextCol from "./TextCol";
import "./style.scss";

const TextCols = ({cols}) => {

  return (
    <div className={"text-cols"}>
      {cols.map((col, index) => <TextCol key={index} title={col.title} text={col.text} />)}
    </div>
  );

};

TextCols.propTypes = {
  cols: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default TextCols;
